module.exports = __webpack_public_path__ + "images/emoji/computer.594e061802f4d90c57c4.png";